const STATIC_CDN = (process.env.REACT_APP_STATIC_CDN || '').replace(/\/$/, '');

/**
 * 解析 video / mindMap 等资源 URL。
 * 支持：完整 URL、以 / 开头的路径、文件名、或带目录前缀的相对路径。
 * 配置 REACT_APP_STATIC_CDN 后，相对路径会拼到 CDN 域名下。
 */
export function resolveStaticMediaUrl(pathOrUrl, mediaFolder) {
  if (!pathOrUrl) return '';

  const trimmed = pathOrUrl.trim();
  if (/^(https?:)?\/\//i.test(trimmed) || trimmed.startsWith('data:')) {
    return trimmed;
  }

  let path;
  if (trimmed.startsWith('/')) {
    path = trimmed;
  } else if (trimmed.startsWith(`${mediaFolder}/`)) {
    path = `/${trimmed}`;
  } else {
    path = `/${mediaFolder}/${trimmed}`;
  }

  return STATIC_CDN ? `${STATIC_CDN}${path}` : path;
}
